import { TrackingHandler } from '../tracking/TrackingHandler';
import { detectFormTest } from '../helpers/detect-form-test';
import { captchaWidgets, resetCaptcha } from '../helpers/captchas';
import { navigateToUrl } from '../helpers/navigation';
import { ConsentFormHandlerFactory } from '../forms/consent-form-handler/ConsentFormHandlerFactory';
import { applyPhoneNumbersToFormData, reportPhoneValidity } from '../helpers/international-phone-inputs';
import { fetchSubmitId as fetchStateSubmitId } from '../forms/core/form-state';
import { addTrackingData, prepareStandardSubmission, trimFormDataFields } from '../forms/core/submission';
export { addTrackingData, trimFormDataFields };
export const getFormName = (formContainer) => {
    return formContainer.dataset.formName || 'undefined';
};
const startCaptcha = (formContainer) => {
    const captchaContainer = formContainer.querySelector('.captcha-container');
    if (!captchaContainer || !captchaContainer.id || !captchaWidgets.has(captchaContainer.id)) {
        return;
    }
    const widget = captchaWidgets.get(captchaContainer.id);
    widget.start();
};
export const getFormState = (formContainer) => ({
    formName: getFormName(formContainer),
    submitId: formContainer.dataset.submitId || undefined,
    vt: formContainer.dataset.vt ? parseInt(formContainer.dataset.vt) : undefined,
    password: formContainer.dataset.password || undefined,
    verificationHash: formContainer.dataset.verification_hash || undefined,
});
export const storeFormState = (formContainer, state) => {
    if (state.submitId) {
        formContainer.dataset.submitId = state.submitId;
    }
    if (state.vt) {
        formContainer.dataset.vt = state.vt.toString();
    }
    if (state.password) {
        formContainer.dataset.password = state.password;
    }
    if (state.verificationHash) {
        formContainer.dataset.verification_hash = state.verificationHash;
    }
};
export const fetchSubmitId = async (formContainer) => {
    const state = getFormState(formContainer);
    await fetchStateSubmitId(state);
    storeFormState(formContainer, state);
};
const startFormCallback = (callbackData) => {
    const formName = getFormName(callbackData.formContainer);
    const formInput = callbackData.event.target.name;
    TrackingHandler.getInstance().formStart(formName, formInput);
    startCaptcha(callbackData.formContainer);
    fetchSubmitId(callbackData.formContainer);
    callbackData.formContainer.classList.toggle('form--started', true);
};
const navigateFormCallback = (callbackData) => {
    const formName = getFormName(callbackData.formContainer);
    let navigationAction = 'goto';
    if (callbackData.requestedStepNumber === callbackData.currentStepNumber - 1) {
        navigationAction = 'previous';
    }
    else if (callbackData.requestedStepNumber === callbackData.currentStepNumber + 1) {
        navigationAction = 'next';
    }
    if (!detectFormTest(callbackData.data)) {
        TrackingHandler.getInstance().formNavigate(formName, callbackData.requestedStepNumber, navigationAction, callbackData.data);
    }
    startCaptcha(callbackData.formContainer);
    return true;
};
const submitModifierCallback = async (callbackData) => {
    const data = trimFormDataFields(callbackData.data);
    if (!applyPhoneNumbersToFormData(callbackData.formContainer, data)) {
        reportPhoneValidity(callbackData.formContainer);
        return null;
    }
    return prepareStandardSubmission(getFormState(callbackData.formContainer), data);
};
const submitFormCallback = (callbackData) => {
    const formName = getFormName(callbackData.formContainer);
    TrackingHandler.getInstance().formSubmit(formName, callbackData.data);
    return true;
};
const submitResultCallback = (callbackData) => {
    TrackingHandler.getInstance().formSubmitResult(getFormName(callbackData.formContainer), callbackData.data, callbackData.xhr.status, callbackData.xhr.response);
    const isSuccess = callbackData.xhr.status >= 200 && callbackData.xhr.status < 300;
    const consentGiven = callbackData.data.consentdataprocess_c === 'TRUE';
    if (isSuccess && !consentGiven) {
        const consentFormHandler = ConsentFormHandlerFactory.getInstance().getHandler();
        if (consentFormHandler) {
            consentFormHandler.displayConsentForm(callbackData.data.submit_id_c, callbackData.formContainer);
        }
    }
    if (!isSuccess) {
        const captchaContainer = callbackData.formContainer.querySelector('.captcha-container');
        if (captchaContainer) {
            resetCaptcha(captchaContainer);
        }
        return true;
    }
    if (callbackData.formContainer.dataset.successPage) {
        navigateToUrl(callbackData.formContainer.dataset.successPage);
        return false;
    }
    return true;
};
export const generalCallbacks = {
    startFormCallback,
    navigateFormCallback,
    submitModifierCallback,
    submitFormCallback,
    submitResultCallback,
};
